import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { IntegrationBannerStore } from 'entities/Integrations/ui/IntegrationBanner/store/integrationBannerStore'

export const IntegrationBanner = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new IntegrationBannerStore(entities))
  const { show, init, dispose, initBanner, initReactions } = store

  useEffect(() => {
    init()
    initReactions()

    return () => {
      dispose()
    }
  }, [])

  useEffect(() => {
    initBanner()
  }, [show])

  return null
})
